import BookingDetails from "./BookingDetails";

export default BookingDetails;